import { InjectionToken } from '@angular/core';
import {
  RdLibModuleCookiesConfig,
  RdLibModuleHermesModeConfig,
  RdLibModuleIdleCheckConfig,
} from '@rd-lib/rd-lib.module.config';
import { PrismicConfig } from '@rd/types/prismic-config.type';
import {
  EnvironmentConnection,
  EnvironmentType,
  Nullable,
  StartsWithHttps,
} from 'global-types';
import { AssetMap } from '../services/asset-service/asset.service';

export const NYDUS_NETWORK_API_BASE_URL = new InjectionToken<string>(
  'NYDUS_NETWORK_API_BASE_URL',
);

export const DEFAULT_CURRENCY_CODE = new InjectionToken<string>(
  'DEFAULT_CURRENCY_CODE',
);

export const DEFAULT_LOCALE_CODE = new InjectionToken<string>(
  'DEFAULT_LOCALE_CODE',
);

export const ENV = new InjectionToken<EnvironmentType>('ENV');

export const PRODUCTION = new InjectionToken<boolean>('PRODUCTION');

export const GUARDHOUSE_API_URL = new InjectionToken<StartsWithHttps>(
  'GUARDHOUSE_API_URL',
);

export const CLIENT_ID = new InjectionToken<string>('CLIENT_ID');

export const CONNECTION = new InjectionToken<EnvironmentConnection>(
  'CONNECTION',
);

export const SCOPE = new InjectionToken<string>('SCOPE');

export const REDIRECT_URI = new InjectionToken<StartsWithHttps>('REDIRECT_URI');

export const TRAVEL_EDGE_BASE_URL = new InjectionToken<StartsWithHttps>(
  'TRAVEL_EDGE_BASE_URL',
);

export const TENANT_PRIVACY_POLICY_URL = new InjectionToken<
  Nullable<StartsWithHttps>
>('TENANT_PRIVACY_POLICY_URL');

export const TENANT_PRIVACY_STATEMENT_URL = new InjectionToken<
  Nullable<StartsWithHttps>
>('TENANT_PRIVACY_STATEMENT_URL');

export const TENANT_TNCS_URL = new InjectionToken<Nullable<StartsWithHttps>>(
  'TENANT_TNCS_URL',
);

export const COMPLIMENTARY_NIGHT_BASE_URL = new InjectionToken<
  Nullable<StartsWithHttps>
>('COMPLIMENTARY_NIGHT_BASE_URL');

export const IS_WEBVIEW = new InjectionToken<boolean>('IS_WEBVIEW');

export const BRAND_NAME = new InjectionToken<string>('BRAND_NAME');

export const PORTAL_NAME = new InjectionToken<string>('PORTAL_NAME');

export const OPEN_EXTERNAL_LINK_IN_OWN_TAB = new InjectionToken<boolean>(
  'OPEN_EXTERNAL_LINK_IN_OWN_TAB',
);

export const SHORT_BRAND_NAME = new InjectionToken<string>('SHORT_BRAND_NAME');

export const STRIPE_API_KEY = new InjectionToken<string>('STRIPE_API_KEY');

export const TENANT_NAME = new InjectionToken<string>('TENANT_NAME');

export const IDLE_CHECK_CONFIG = new InjectionToken<RdLibModuleIdleCheckConfig>(
  'IDLE_CHECK_CONFIG',
);

export const INCLUDE_CLOSING_POINTS_ACCOUNTS = new InjectionToken<boolean>(
  'INCLUDE_CLOSING_POINTS_ACCOUNTS',
);

export const SESSION_CHECK_POLL_INTERVAL = new InjectionToken<number>(
  'SESSION_CHECK_POLL_INTERVAL',
);

export const COOKIES_CONFIG = new InjectionToken<RdLibModuleCookiesConfig>(
  'COOKIES_CONFIG',
);

export const SUPPORTED_LOCALES = new InjectionToken<string[]>(
  'SUPPORTED_LOCALES',
);

export const POINTS_TRANSACTION_ENABLED = new InjectionToken<boolean>(
  'POINTS_TRANSACTION_ENABLED',
);

export const PRISMIC_CONFIG = new InjectionToken<PrismicConfig>(
  'PRISMIC_CONFIG',
);

export const CASH_NUMBER_DIGITS_INFO = new InjectionToken<string>(
  'CASH_NUMBER_DIGITS_INFO',
);

export const POINTS_NUMBER_DIGITS_INFO = new InjectionToken<string>(
  'POINTS_NUMBER_DIGITS_INFO',
);

export const POINTS_TRANSACTION_DIGITS_INFO = new InjectionToken<string>(
  'POINTS_TRANSACTION_DIGITS_INFO',
);

export const USE_CUSTOM_PAGE_TITLE = new InjectionToken<boolean>(
  'USE_CUSTOM_PAGE_TITLE',
);

export const APP_ID = new InjectionToken<string>('APP_ID');

export const ASSET_MAP = new InjectionToken<AssetMap>('ASSET_MAP');

export const HERMES_MODE = new InjectionToken<RdLibModuleHermesModeConfig>(
  'HERMES_MODE',
);

export const RD_PLATFORM_MAINTENANCE_UNLEASH_KEY = 'rd_platform_maintenance';
export const RD_PLATFORM_MAINTENANCE_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('RD_PLATFORM_MAINTENANCE_ENABLED');
